(function($) {
    $.fn.filterElements = function(method) {
        let defaults = {
			caseInsensitive: false,
			parentElementWrapper: null, 
			childElementToFilter: null,
            clearAction: null,
            notFound: null,
			controlNext: false, 
            min: 2
        }

        let settings = {}
        let methods = {

            init : function(options) {

                settings = $.extend({}, defaults, options);
				if(settings.parentElementWrapper === null || settings.childElementToFilter === null){
					$.error( 'Required attributes "parentElementWrapper" or "childElementToFilter" are not provided. Please check options passed!');
				}
				
                return this.each(function() {

                    let $element = $(this); 
					
					$(this).on("keyup", function() {
						let value;
						if (settings.caseInsensitive){
							value = $(this).val().toLowerCase();
						}
						else{
							value = $(this).val();
						}

                        if (value.length > 0) {
                            $(settings.clearAction).fadeIn("fast");
                        } else {
                            $(settings.clearAction).fadeOut("fast");
                        }
                        

                        if (value.length >= settings.min) {
                            $(settings.childElementToFilter +'.active').toggleClass('active').find('.faq-content').slideToggle();
                            $(settings.parentElementWrapper + ' ' + settings.childElementToFilter).filter(function(){
                                let toggleIt;
 
                                if (settings.caseInsensitive){
                                    toggleIt = $(this).text().toLowerCase().indexOf(value) > -1;
                                }
                                else{
                                    toggleIt = $(this).text().indexOf(value) > -1;
                                }

                                if(toggleIt) {
                                    $(this).css("display", "block").addClass('filtered');
    
                                    $(this).removeHighlight().highlight(value);
                                    if(settings.controlNext){
                                        $(this).next().css("display", "block").addClass('filtered');
                                    }

                                    methods.showNotFound(settings);
                                } else{
                                    $(this).css("display", "none").removeClass('filtered');
                                    if(settings.controlNext){
                                            $(this).next().css("display", "none").removeClass('filtered');
                                    }
                                    methods.showNotFound(settings);
                                }
                            });
                        } else {
                            $(settings.parentElementWrapper).removeHighlight();
                            $(settings.childElementToFilter).css("display", "block");

                            $(settings.notFound).removeClass('show');
                        }
					});

                    $(settings.clearAction).on( "click", function() {
                        $element.val('').trigger( "keyup" );
                        $(settings.notFound).removeClass('show');
                    });

                });

            },
            showNotFound : function(settings) {
                if ($(settings.childElementToFilter + '.filtered').length > 0) {
                    $(settings.notFound).removeClass('show');
                } else {
                    $(settings.notFound).addClass('show');
                }
            }
        }

        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error( 'Method "' +  method + '" does not exist in filterElements plugin!');
        }
    }

    $.fn.highlight = function(pat) {
        function innerHighlight(node, pat) {
         var skip = 0;
         if (node.nodeType == 3) {
          var pos = node.data.toUpperCase().indexOf(pat);
          if (pos >= 0) {
           var spannode = document.createElement('span');
           spannode.className = 'highlight-item';
           var middlebit = node.splitText(pos);
           var endbit = middlebit.splitText(pat.length);
           var middleclone = middlebit.cloneNode(true);
           spannode.appendChild(middleclone);
           middlebit.parentNode.replaceChild(spannode, middlebit);
           skip = 1;
          }
         }
         else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
          for (var i = 0; i < node.childNodes.length; ++i) {
           i += innerHighlight(node.childNodes[i], pat);
          }
         }
         return skip;
        }
        return this.length && pat && pat.length ? this.each(function() {
         innerHighlight(this, pat.toUpperCase());
        }) : this;
       };

       $.fn.removeHighlight = function() {
        return this.find("span.highlight-item").each(function() {
         this.parentNode.firstChild.nodeName;
         with (this.parentNode) {
          replaceChild(this.firstChild, this);
          normalize();
         }
        }).end();
       };
})(jQuery);